$(function () {
	$.nette.ext('discountVoucherToggler', {
		init: function() {
			var snippetsExt = this.ext('snippets', true);
			var ext = this;

			snippetsExt.after(function($el) {
				ext.init.call(ext, $el);
			});

			this.init($(document));
		}
	}, {
		selected: false,
		init: function ($el) {
			var $discountBoxVoucherToggler = $el.find('#discount-box-voucher-toggler');
			$discountBoxVoucherToggler.prop('checked', this.selected);
			this.handlerAttached(this.selected);

			var self = this;
			$discountBoxVoucherToggler.on('change', function (e) {
				self.selected = !self.selected;
				self.handlerAttached(self.selected);
			});
		},
		handlerAttached: function (selected) {
			$('#discount-box-voucher').toggleClass('active', selected);
		}
	})
});
